import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
import { createTicketsSlaInsightsApi } from '.';
export var createTicketsSlaInsightsApiTestkit = function (parent) {
    var fakeHttp = createHttpTestKit();
    var api = createTicketsSlaInsightsApi(parent, fakeHttp);
    var tickets = "".concat(parent, "/analytics/tickets");
    var slaBase = "".concat(tickets, "/sla");
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, "".concat(tickets, "/overview")),
        whenGetComplianceCumulative: createFakePostResponder(fakeHttp, "".concat(slaBase, "/compliance/cumulative")),
        whenGetComplianceHistogram: createFakePostResponder(fakeHttp, "".concat(slaBase, "/compliance/histogram")),
        whenGetElapsedTimeCumulative: createFakePostResponder(fakeHttp, "".concat(slaBase, "/elapsedTime/cumulative")),
        whenGetElapsedTimeHistogram: createFakePostResponder(fakeHttp, "".concat(slaBase, "/elapsedTime/histogram")),
        whenGetMissCountCumulative: createFakePostResponder(fakeHttp, "".concat(slaBase, "/missCount/cumulative")),
        whenGetMissCountHistogram: createFakePostResponder(fakeHttp, "".concat(slaBase, "/missCount/histogram")),
        whenGetMissTimeCumulative: createFakePostResponder(fakeHttp, "".concat(slaBase, "/missTime/cumulative")),
        whenGetMissTimeHistogram: createFakePostResponder(fakeHttp, "".concat(slaBase, "/missTime/histogram")),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map